import { addonMinPlanKey, ServiceCatalog } from "./ServiceCatalog.js";
const RANK = {
    foundation: 0,
    payg: 1,
    starter: 2,
    growth: 3,
    pro: 4,
};
/** Floors from the ServiceCatalog add-on table (single source for marketing). */
export function catalogAddonFloorsFromServiceCatalog() {
    return ServiceCatalog.addons.map((a) => ({
        addonKey: a.key,
        minPlanKey: a.minPlanKey,
    }));
}
/** @deprecated Prefer catalogAddonFloorsFromServiceCatalog — kept for API parity tests. */
export const CATALOG_ADDON_FLOORS = catalogAddonFloorsFromServiceCatalog();
/** Resolves which hosting plans are disabled for a build + selected add-ons. */
export class HostingFloor {
    floors;
    constructor(floors = catalogAddonFloorsFromServiceCatalog()) {
        this.floors = floors;
    }
    static rank(plan) {
        return RANK[plan] ?? -1;
    }
    static buildAllowsFoundation(build) {
        return build == null || build === "spark" || build === "brand";
    }
    static floorLabel(rank) {
        if (rank >= RANK.pro)
            return "Pro";
        if (rank >= RANK.growth)
            return "Growth";
        if (rank >= RANK.starter)
            return "Starter";
        if (rank >= RANK.payg)
            return "Pay as you go";
        return "";
    }
    /** Catalog floor, with Custom + second location allowed on PAYG (#660). */
    static minPlanKeyFor(addonKey, build) {
        const row = ServiceCatalog.addons.find((a) => a.key === addonKey);
        const fallback = row?.minPlanKey ?? "payg";
        return addonMinPlanKey(addonKey, build, fallback);
    }
    requiredRank(selectedAddonKeys, build = null) {
        const byAddon = new Map(this.floors.map((f) => [f.addonKey, f.minPlanKey]));
        let max = 0;
        for (const key of selectedAddonKeys) {
            const fallback = byAddon.get(key) ?? "payg";
            const min = addonMinPlanKey(key, build, fallback);
            const r = HostingFloor.rank(min);
            if (r > max)
                max = r;
        }
        return max;
    }
    isDisabled(plan, build, selectedAddonKeys) {
        if (plan === "foundation" && !HostingFloor.buildAllowsFoundation(build)) {
            return true;
        }
        const floor = this.requiredRank(selectedAddonKeys, build);
        if (floor <= 0)
            return false;
        if (plan === "foundation")
            return true;
        return HostingFloor.rank(plan) < floor;
    }
}
//# sourceMappingURL=HostingFloor.js.map